import { render, staticRenderFns } from "./MomoRedeem.vue?vue&type=template&id=d8bdcc54&"
import script from "./MomoRedeem.vue?vue&type=script&lang=js&"
export * from "./MomoRedeem.vue?vue&type=script&lang=js&"
import style0 from "./MomoRedeem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports